import intlTelInput from 'intl-tel-input';
import helpers from '../helpers';
import popup from './popup';
import ssoAuth from './sso-auth';
import './intlTelInputUtils';
import requestSecondStep from './request-simple-second-step';


const pageClass = document.querySelector('body').classList;
const phoneInputID = '#phoneNoResident';
const $form = document.querySelector('#request-simple');
const formNonResident = document.querySelector('#form-nonresident-page');
const $phoneNoResident = (!formNonResident ) ? document.querySelector(phoneInputID) : null;
export const agentsPage = document.querySelector('.page-agents');
const agentsFormPage = document.querySelector('.page-form');

let onceShow = true;
let dropdownGroup;

const phoneInputIDRes = '#phoneResident';
const $phoneResident = document.querySelector(phoneInputIDRes);

const utm = {
	utm_source: '{source}',
	utm_medium: 'cpc',
	utm_content: 'gid|{gbid}|ad_id|{ad_id}|phrase_id|{phrase_id}',
	utm_campaign: '{campaign_id}',
	utm_term: '{keyword}',
};

const isValidUrl = (urlString) => {
	let urlPattern1 = new RegExp('^(https?:\\/\\/)?' + // validate protocol
		'((([a-z\\d]([a-z\\d-]*[a-z\\d]))\\.)+[a-z]{2,}|' + // validate domain name
		'((\\d{1,3}\\.){3}\\d{1,3}))' + // validate OR ip (v4) address
		'(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // validate port and path
		'(\\?[;&a-z\\d%_.~+=-]*)?' + // validate query string
		'(\\#[-a-z\\d_]*)?$', 'i'); // validate fragment locator

	// cyrillic pattern
	let urlPattern2 = new RegExp('^(https?:\\/\\/)?' + // validate protocol
		'((([а-яё|а-яё\\d]([а-яё\\d-]*[а-яё\\d]))\\.)+[а-яё]{2,}|' + // validate domain name
		'((\\d{1,3}\\.){3}\\d{1,3}))' + // validate OR ip (v4) address
		'(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // validate port and path
		'(\\?[;&a-z\\d%_.~+=-]*)?' + // validate query string
		'(\\#[-a-z\\d_]*)?$', 'i'); // validate fragment locator

	let result = urlPattern1.test(urlString) ? urlPattern1.test(urlString) : urlPattern2.test(urlString);

	return result;
};

/* eslint-disable */
const _tmr = window._tmr || (window._tmr = []);

function gtag_report_conversion(url) {
	let callback = function () {
		if (typeof(url) != 'undefined') {
			window.location = url;
		}
	};

	// ga('send', 'event', {
	// 	eventCategory: 'conversion',
	// 	eventAction: 'conversion',
	// 	sendTo: 'AW-622861531/s6weCPH1toMDENu5gKkC',
	// 	eventCallback: callback,
	// });
	return false;
}
/* eslint-enable */
/* eslint-disable new-cap */
/* eslint-disable no-undef */

// function showComment(e) {
// 	const wrapper = document.querySelector('.form__group--comment');
// 	const height = document.querySelector('.form__item--comment').clientHeight;

// 	if (e.target.value.length > 0) {
// 		wrapper.style.height = `${height + 1}px`;
// 	}
// }

function getHeight(elem) {
	return Math.max(
		elem.scrollHeight,
		elem.offsetHeight,
		elem.clientHeight,
	);
}

// function showContent(selector) {
// 	const wrapper = document.querySelector(selector);
// 	const height = getHeight(wrapper);

// 	wrapper.style.height = `${height}px`;

// 	setTimeout(() => {
// 		wrapper.classList.add('is-active');
// 	}, 500);
// }


function toogleGroup(openGroup) {
	const formGroupMsg = document.querySelector('.form__group--msg');
	const openEl = document.querySelector(openGroup);
	const hideEl = document.querySelector('.form__groups .form__group.is-active');
	const height = getHeight(openEl);

	if (hideEl) {
		hideEl.style.height = '0px';
		hideEl.classList.remove('is-active');
	}

	if (!formGroupMsg.classList.contains('is-active')) {
		const heightFormGroupMsg = getHeight(formGroupMsg);
		formGroupMsg.style.height = `${heightFormGroupMsg}px`;
		formGroupMsg.classList.add('is-active');
	}

	openEl.style.height = `${height}px`;
	openEl.classList.add('is-active');
}

function setValuesCompanny(data) {
	const name = document.querySelector('#headName');
	const company = document.querySelector('#company');

	company.value = data.name.short_with_opf;

	company.classList.add('is-active', 'valid');
	company.classList.remove('error');

	if (name) {
		name.value = data.inn.length === 10 ? data.management.name : data.name.full;

		name.classList.add('is-active', 'valid');
		name.classList.remove('error');
	}
}

function cleanValusCompany() {
	const name = document.querySelector('#headName');
	const company = document.querySelector('#company');

	company.value = '';

	company.classList.remove('is-active');

	if (name) {
		name.value = '';
		name.classList.remove('is-active');
	}
}

// function setErrorLableInn() {
// 	const label = document.createElement('label');
// 	label.classList.add('error');
// 	label.setAttribute('for', 'inn');
// 	label.id = 'inn-error';
// 	document.getElementById('inn').parentNode.appendChild(label);

// 	label.innerText = 'Неверно указан ИНН';
// 	label.style.display = 'block';
// }

function fillInnList(data, e) {
	let parentNode = e.target.parentElement.parentElement;
	let list = document.getElementById('form__drop-list--inn');
	if (!list) {
		list = document.createElement('ul');
		list.classList.add("form__drop-list--inn");
		list.classList.add("form__drop-list");
		list.setAttribute('id', 'form__drop-list--inn');
		parentNode.appendChild(list);
	}
	$('#form__drop-list--inn').empty();
	clearErrorLabelInnDropList();
	if (window.screen.width <= 1023) {
		if (data.suggestions.length <= 2) {
			list.style.height = (69.5*data.suggestions.length)+"px";
		} else {
			list.style.height = '141px';
		}
	} else {
		if (data.suggestions.length <= 4) {
			list.style.height = (69.5*data.suggestions.length)+"px";
		} else {
			list.style.height = '278px';
		}
	}

	$.each(data.suggestions, function(key, item) {
		let companyName = item.value;
		let companyInn = item.data.inn;
		$('#form__drop-list--inn').prepend(`
			<li class="form__drop-item" data-inn="${companyInn}">
				<p class="form__drop-item--inn">ИНН: ${companyInn}</p>
				<p class="form__drop-item--company-name">${companyName}</p>
			</li>
		`);
	});

	if (data.suggestions.length === 0 && list) {
		list.remove();
		setErrorLabelInnDropList();
	}
}

function clearErrorLabelInnDropList() {
	let label = document.getElementById('inn-error');
	let innInput = document.getElementById('inn');
	if (label && innInput.classList.contains('error')) {
		label.remove();
		innInput.classList.remove('error');
	}
}

function setErrorLabelInnDropList() {
	let inn = document.getElementById('inn-error');
	let innInput = document.getElementById('inn');
	if (!inn) {
		let checkbox = document.querySelector('.form__item--checkbox');
		checkbox.classList.remove('is-hidden');

		const label = document.createElement('label');
		label.classList.add('error');
		label.setAttribute('for', 'inn');
		label.id = 'inn-error';
		document.getElementById('inn').parentNode.appendChild(label);

		label.innerText = 'Ваш ИНН не найден, написан с ошибкой или вы самозанятый';
		label.style.display = 'block';

		innInput.classList.add('error');
	}
}


export const Analytics = {
	reachGoal: (target) => {
		if (typeof window.ym === 'function') {
			window.ym(25538402, 'reachGoal', target);
		}
	},

	castomEvent: (name, data) => {
		if (typeof window.ym === 'function') {
			window.ym(25538402, name, data);
		}
	},

	push: (event) => {
		if (typeof window.dataLayer === 'undefined') {
			window.dataLayer = [];
		}

		window.dataLayer.push(event);
	},
};

function checkEmployed(form) {
	const checkboxEmployed = form.querySelector('[name="self-employed"]');
	let result;

	if (checkboxEmployed) {
		result = checkboxEmployed.checked ? 1 : 0;
	} else {
		result = '-';
	}

	return result;
}

function sendAjaxForm(form, url) {
	let isResident = false;
	let dataParams = new FormData();
	let messages = {
		success: '<p>Спасибо, что заполнили форму!</p><p>Мы скоро с вами свяжемся</p>',
		error_message: '<p>Ошибка!</p>',
		error: '<p>Что-то пошло не так!</p><p>Попробуйте повторить</p>',
	};

	for (const pair of new FormData(form)) {
		if (pair[0] !== 'phoneNumberVision') {
			dataParams.append(pair[0], pair[1]);
		}

		if (pair[0] === 'resident' && pair[1] === 'yes') {
			isResident = true;
		}

		if (pair[0] === 'resident' && pair[1] === 'online-kassa') {
			isResident = 'online-kassa';
		}

		if (pair[0] === 'resident' && pair[1] === 'agents') {
			isResident = 'agents';
		}
	}

	if (pageClass.contains('page-subscriptions')) {
		dataParams.append('type', 'CloudPayments');
	}

	for (let i = 0; i < localStorage.length; i++) {
		let key = localStorage.key(i);
		dataParams.append(key, localStorage.getItem(key));
	}
	// for (const pair of new FormData(form)) {
	// 	console.log(pair);
	// }

	if (agentsPage) {
		dataParams.append('agents', true);
	}

	let request = new XMLHttpRequest();
	request.open('POST', url, true);

	// eslint-disable-next-line func-names
	request.addEventListener('load', function () {
		if (this.status >= 200 && this.status < 400) {
			let response = JSON.parse(this.response);
			if (response.status === 'success') {
				//менять тут?
				form.reset();
				if ($('#country').length != 0) {
					$('.country__name').text('Где зарегистрирован бизнес');
					$('.country__name').removeClass('country__name--selected');
					$('#country').val('');
				}

				popup.openPopup(messages.success);
				gtag_report_conversion();

				if (typeof response.lead.result.dealId !== 'undefined') {
					if (isResident === true) {
						// Форма Резиденты
						// MyTarget
						_tmr.push({
							type: 'reachGoal',
							id: 3179978,
							goal: 'Lead',
						});

						// ga('send', 'universal_event', {
						// 	eventCategory: 'GA_Form',
						// 	eventAction: 'GA_submit',
						// 	universal_event_systems: 'GA_FP_YM',
						// 	eventLabel: 'submit_form_connection',
						// 	userId: response.lead.result.dealId,
						// });

						Analytics.castomEvent('params', {
							deal_id: response.lead.result.dealId,
						});
					} else if (isResident === 'online-kassa') {
						// Форма online-kassa
						_tmr.push({
							type: 'reachGoal',
							id: 3179978,
							goal: 'lead_kassa',
						});

						Analytics.castomEvent('params', {
							deal_id: response.lead.result.dealId,
						});

						Analytics.reachGoal('formleadkassir');

						// ga('send', 'event', 'lead', 'form', 'kassir');
					} else if (isResident === 'agents') {
						if (agentsFormPage) {
							Analytics.reachGoal('formleadagents1');

							gtag('event', 'form', {
								event_category: 'lead',
								event_label: 'agents1',
								value: 'value',
							});
						} else {
							Analytics.reachGoal('formleadagents');

							gtag('event', 'form', {
								event_category: 'lead',
								event_label: 'agents',
								value: 'value',
							});
							VK.Goal('leadagents');
						}
					} else if (document.querySelector('.page-form-cloud-cheki')) {
						Analytics.reachGoal('formleadchecks');
					} else if (document.querySelector('.page-form-tips')) {
						Analytics.reachGoal('formleadtips');
					} else {
						// Форма Нерезиденты
						_tmr.push({
							type: 'reachGoal',
							id: 3179978,
							goal: 'lead_nonresidents',
						});

						Analytics.reachGoal('formleadnonresident');
						Analytics.castomEvent('params', {
							deal_id: response.lead.result.dealId,
						});

						// ga('send', 'event', 'lead', 'form', 'nonresident');

						// ga('send', 'universal_event', {
						// 	eventCategory: 'GA_Form',
						// 	eventAction: 'GA_submit',
						// 	universal_event_systems: 'GA_FP_YM',
						// 	eventLabel: 'submit_form_connection_nonresidents',
						// 	userId: response.lead.result.dealId,
						// });
					}

					VK.Goal('lead');

					switch (true) {
						case pageClass.contains('page-form-residents'):
							// Отправка формы заявки со страницы резиденты
							Analytics.reachGoal('formleadresidents');
							// ga('send', 'event', 'lead', 'form', 'residentpage');
							break;
						case pageClass.contains('page-home'):
							// Отправка формы заявки главная страница
							Analytics.reachGoal('formleadmainpage');
							// ga('send', 'event', 'lead', 'form', 'resident');
							break;
						case pageClass.contains('page-public'):
							// Отправка формы заявки общественное питание
							Analytics.reachGoal('formleadfood');
							// ga('send', 'event', 'lead', 'form', 'food');
							break;
						case pageClass.contains('page-ecommerce'):
							// Отправка формы заявки E-commerce
							Analytics.reachGoal('formleadecommerce');
							// ga('send', 'event', 'lead', 'form', 'ecommerce');
							break;
						case pageClass.contains('page-finance'):
							// Отправка формы заявки Онлайн платежи в финансах
							Analytics.reachGoal('formleadfinance');
							// ga('send', 'event', 'lead', 'form', 'finance');
							break;
						case pageClass.contains('page-entertainment'):
							// Отправка формы заявки Онлайн платежи сфера развлечений
							Analytics.reachGoal('formleadenvironment');
							// ga('send', 'event', 'lead', 'form', 'environment');
							break;
						case pageClass.contains('page-edu'):
							// Отправка формы заявки Онлайн платежи образование
							Analytics.reachGoal('formleadeducation');
							// ga('send', 'event', 'lead', 'form', 'education');
							break;
						case pageClass.contains('page-subscriptions'):
							// Отправка формы заявки Сервис подписок
							Analytics.reachGoal('formleadrecurrent');
							break;
						default:
						// do nothing
					}
				}
			} else {
				popup.openPopup(`${messages.error_message}<p>${response.message}</p>`);
			}
		} else {
			popup.openPopup(messages.error);
		}
	});

	request.addEventListener('error', () => {
		popup.openPopup(messages.error);
	});

	dataParams.delete('self-employed');
	dataParams.append('self-employed', checkEmployed(form));


	//или тут

	request.send(dataParams);
}

function checkNumber(value) {
	const val = value.replace(/[^+\d]/g, '');

	switch (true) {
		// Rus and Kz
		case val.includes('+7') && val.length >= 11:
			return true;
		// Belarus
		case val.includes('+375') && val.length >= 11:
			return true;
		// Latvia
		case val.includes('+371') && val.length >= 11:
			return true;
		// Estonia
		case val.includes('+372') && val.length >= 11:
			return true;
		// Lithuania
		case val.includes('+370') && val.length >= 11:
			return true;
		// Indonesia
		case val.includes('+62') && val.length >= 11:
			return true;
		// Thailand
		case val.includes('+66') && val.length >= 11:
			return true;
		// Singapore
		case val.includes('+65') && val.length >= 11:
			return true;
		// China
		case val.includes('+86') && val.length >= 11:
			return true;
		// Hong Kong and Taiwan
		case val.includes('+852') && val.length >= 11:
			return true;
		// Norway
		case val.includes('+472') && val.length >= 11:
			return true;
		// India
		case val.includes('+91') && val.length >= 11:
			return true;
		default: return false;
	}
}

function changeInputMask(e) {
	const val = e.target.value.replace(/[^+\d]/g, '');

	switch (true) {
		// Rus and Kz
		case val.includes('+7') :
			Inputmask({
				mask: '+9 (999) 999-99-99',
			}).mask('#phone');
			break;
		// Belarus
		case val.includes('+375') || val.includes('+380'):
			Inputmask({
				mask: '+999 (99) 999-99-99',
			}).mask('#phone');
			break;
		// Latvia
		case val.includes('+371') || val.includes('+357'):
			Inputmask({
				mask: '+999 (99) 999-999',
			}).mask('#phone');
			break;
		// Estonia
		case val.includes('+372') :
			Inputmask({
				mask: '+999 9999-9999',
			}).mask('#phone');
			break;
		// Lithuania
		case val.includes('+370') || val.includes('+972'):
			Inputmask({
				mask: '+999 (99) 999-999',
			}).mask('#phone');
			break;
		// Indonesia
		case val.includes('+62') :
			Inputmask({
				mask: '+99 (999) 999-99-99',
			}).mask('#phone');
			break;
		// Thailand
		case val.includes('+66') :
			Inputmask({
				mask: '+99 (99) 999-99-99',
			}).mask('#phone');
			break;
		// Singapore
		case val.includes('+65') :
			Inputmask({
				mask: '+99 9999-99-99',
			}).mask('#phone');
			break;
		// China
		case val.includes('+86') :
			Inputmask({
				mask: '+99 (999) 9999-99-99',
			}).mask('#phone');
			break;
		// Hong Kong and Taiwan
		case val.includes('+852') || val.includes('+886'):
			Inputmask({
				mask: '+999 9999-99-99',
			}).mask('#phone');
			break;
		// Norway
		case val.includes('+472'):
			Inputmask({
				mask: '+999 (999) 999-99-99',
			}).mask('#phone');
			break;
		// India
		case val.includes('+91'):
			Inputmask({
				mask: '+99 (9999) 999-999',
			}).mask('#phone');
			break;
		default: Inputmask({
			mask: '+9 (999) 999-99-99',
		}).mask('#phone');
	}
}

/**
 * Получение GET параметра из url
 * @param string name
 * @return string|null
 */

function getUrlParam(name) {
	let params = [];

	window.location.search.substring(1).split('&').forEach((param) => {
		param = param.split('=');
		if (param[0] && param[1]) {
			params[param[0]] = param[1];
		}
	});

	return typeof params[name] !== 'undefined' ? params[name] : null;
}

function containerLockScrollOnHover(element) {
	element.addEventListener('mouseenter', () => {
		if (window.scrollbar) {
			window.scrollbar.updatePluginOptions('modal', {open: true});
		}
	});

	element.addEventListener('mouseleave', () => {
		if (window.scrollbar) {
			window.scrollbar.updatePluginOptions('modal', {open: false});
		}
	});
}

function encodeState(state) {
	return btoa(state);
}

function setStateForm(key, value) {
	let form = localStorage.getItem('form') ?? null;

	if (form) {
		let formJSON = JSON.parse(form);
		formJSON[key] = value;
		localStorage.setItem('form', JSON.stringify(formJSON));
	}
}
function getStateFormAsJSON() {
	return JSON.parse(localStorage.getItem('form'));
}



const init = () => {
	let countryWrapper = $(".country");

	if (formNonResident) {
		$('#phoneNoResident').after('<input type="hidden" name="phoneNumber" value="">');

		let countrySelected = $('.country__selected'),
			countryList = $('.country__list'),
			countryDropdown = $('.country__dropdown'),
			countryInput = $('#country'),
			countryName = $('.country__name');

		const countryToggleState = () => {
			countryList.toggleClass('is-hidden');
			countrySelected.toggleClass('is-active');
			countryDropdown.toggleClass('country__dropdown--rotated');
		}

		const selectCurrentCountryBehavior = (item) => {
			countryName.addClass('country__name--selected');
			let selectedCountryFlag = item.find('.country__icon')
				.attr('class').match(/(^|\s)(country\__icon\--[^\s]*)/)[0];

			countryName.html(`<p><span class="country__icon ${selectedCountryFlag}"></span> ${item.text()}</p>`);
			countryInput.attr('value', item.text().replace(/\s/g, ''));
		}

		const clearCountryError = () => {
			countrySelected.removeClass('error');
			$('#country-error').remove();
		}
		$(document).ready(function() {
			$(document).on('click', function(e) {
				if ($('.country__selected').hasClass('is-active')) {
					countryToggleState();
				}
			})
			$('#request-simple').on('submit', function() {
				if (!countryInput.attr('value')) {
					countrySelected.addClass('error');
					if (!$('#country-error').length) {
						countrySelected.after('<span id="country-error" class="error" for="country">Выберите страну</span>');
					}
				} else {
					$('input[name="phoneNumber"]').val($('#phoneNoResident').val());
				}
			});

			$('.country__item').on('click', function(e) {
				e.stopPropagation();
				selectCurrentCountryBehavior($(this));
				countryToggleState();
			});

			if (countryWrapper.length) {
				countryWrapper.on('click', function(e) {
					e.stopPropagation();
					clearCountryError()
					countryToggleState();
					containerLockScrollOnHover(document.querySelector('.country__list'));
				});
			}
		});
	}
	if ($form) {
		// eslint-disable-next-line
		for (let key in utm) {
			if (getUrlParam(key) !== null) {
				localStorage.setItem(key, getUrlParam(key));
			}
		}

		Inputmask({
			mask: '+9 (999) 999-9999',
		}).mask('#phone');

		helpers.$document
			.on('focus', '.form__input', (e) => {
				$(e.currentTarget).addClass('is-active');
				$(e.currentTarget).closest('.form__item').addClass('is-active');
			})
			.on('blur', '.form__input', (e) => {
				if ($(e.currentTarget).val() < 1) {
					$(e.currentTarget).removeClass('is-active');
					$(e.currentTarget).closest('.form__item').removeClass('is-active');
				}
			})
			.on('input paste', '#inn', (e) => {
				e.stopPropagation();
				searchCompanyByINN(e);
				if (e.target.value == 0) {
					$('#checkbox-self-employed').parent().addClass('is-hidden');
				}
				// Inputmask(
				// 	{regex: "^(\\d{10}|\\d{12})$"
				// }).mask('#inn');
			})
			// .on('', '#inn', (e) => {
			// 	searchCompanyByINN(e);
			// })
			.on('click', window, (e) => {
				if ($('#form__drop-list--inn')) {
					if ( !$('#form__drop-list--inn').hasClass('is-hidden') ) {
						$('#form__drop-list--inn').remove();
					}
				}
			})
			.on('click', '#form__drop-list--inn', (e) => {
				e.stopPropagation();
			})
			.on('click', '#inn', (e) => {
				e.stopPropagation();
			})
			.on('click', 'li.form__drop-item[data-inn]', (e) => {
				// e.stopPropagation();
				$('#inn').val(e.currentTarget.getAttribute('data-inn'));
				$('#form__drop-list--inn').remove();
				if ($('#inn').val() !== 0) {
					$('#checkbox-self-employed').parent().addClass('is-hidden');
				}
			})
			.on('focusout','#inn', (e) => {
				$('#form__drop-list--wrapper').remove();
			})
			.on('change', '#checkbox-self-employed', (e) => {
				// clearErrorLabelInnDropList();
			})
			.on('input', '#phone', changeInputMask)
			// eslint-disable-next-line no-unused-vars
			.on('input', '#phoneResident', (e) => {
				// add active class for comment field
				// const formGroupMsg = document.querySelector('.form__group--msg');

				// if (!formGroupMsg.classList.contains('is-active')) {
				// 	const heightFormGroupMsg = getHeight(formGroupMsg);
				// 	formGroupMsg.style.height = `${heightFormGroupMsg}px`;
				// 	formGroupMsg.classList.add('is-active');
				// }
			})
			// eslint-disable-next-line no-unused-vars
			.on('input', '#phoneNoResident', (e) => {
				// add active class for comment field
				// const formGroupMsg = document.querySelector('.form__group--msg');
				// if (!formGroupMsg.classList.contains('is-active')) {
				// 	const heightFormGroupMsg = getHeight(formGroupMsg);
				// 	formGroupMsg.style.height = `${heightFormGroupMsg}px`;
				// 	formGroupMsg.classList.add('is-active');
				// }
			})
			.on('change', 'input[name="preference"]', (e) => {
				const dropdown = document.querySelector('.form__dropdown');
				const dropdownTitle = document.querySelector('.form__dropdown .drop-down-js');
				const dataGroup = e.target.dataset.group;
				const group = `.form__group--${dataGroup}`;
				dropdownGroup = dataGroup;

				toogleGroup(group, dataGroup);
				dropdown.classList.remove('form__dropdown--error');
				dropdownTitle.classList.add('is-selected');

				if (dropdownGroup === 'email') {
					$.validator.addClassRules('email', {
						required: true,
						email: true,
						messages: false,
					});

					$.validator.addClassRules('phone', {
						required: false,
					});

					$.validator.addClassRules('phoneNoResident', {
						required: false,
					});

					$.validator.addClassRules('phoneResident', {
						required: false,
					});
				} else {
					$.validator.addClassRules('email', {
						required: false,
						email: false,
					});

					$.validator.addClassRules('phone', {
						required: true,
						validationNumber: '',
					});

					$.validator.addClassRules('phoneNoResident', {
						required: 'Введите номер телефона',
						phoneNumValidation: '',
					});

					$.validator.addClassRules('phoneResident', {
						required: 'Введите номер телефона',
						//matches: "[0-9]+",
						matches: "[A-Za-z0-9!#%&*+,.:;=?@_`\\$\\[\\]\\^\\-\\/]+",
						phoneNumValidation: '',
					});
				}
			})
			.on('click', '.form__button', (e) => {
				const dropdown = document.querySelector('.form__dropdown');
				const dropdownInput = document.querySelectorAll('.form__dropdown input[name="preference"]:checked');
				if (dropdown) {
					if (dropdownInput.length === 0) {
						e.preventDefault();
						dropdown.classList.add('form__dropdown--error');
					}
				}
			});

		if ($phoneNoResident) {
			const label = document.querySelector('label[for="phoneNoResident"]');

			const labelLeft = () => {
				let paddingInput = $phoneNoResident.style.paddingLeft;
				label.style.left = paddingInput;
			};

			setTimeout(() => {
				const $iti = document.querySelector('.iti');

				$iti.append(label);
				labelLeft();
			}, 250);

			const iti = intlTelInput($phoneNoResident, {
				...agentsPage ? {initialCountry: 'ru'} : {initialCountry: 'at'},
				autoPlaceholder: 'aggressive',
				separateDialCode: true,
				nationalMode: false,
				hiddenInput: 'phoneNumber',
				localizedCountries: {
					...agentsPage ? {
						'ru': 'Россия',
						'th': 'Тайланд',
						'in': 'Индия',
						'id': 'Индонезия',
						'ph': 'Филиппины',
						'am': 'Армения',
						'ge': 'Грузия',
						'uz': 'Узбекистан',
						'kg': 'Кыргызстан',
						'by': 'Беларусь',
						'rs': 'Сербия',
						'me': 'Черногория',
						'ae': 'ОАЭ',
					} : {},
					kz: 'Казахстан',
					at: 'Австрия',
					be: 'Бельгия',
					bg: 'Болгария',
					hu: 'Венгрия',
					de: 'Германия',
					gr: 'Греция',
					dk: 'Дания',
					ie: 'Ирландия',
					es: 'Испания',
					it: 'Италия',
					cy: 'Кипр',
					lv: 'Латвия',
					lt: 'Литва',
					lu: 'Люксембург',
					mt: 'Мальта',
					nl: 'Нидерланды',
					no: 'Норвегия',
					pl: 'Польша',
					pt: 'Португалия',
					ro: 'Румыния',
					sk: 'Словакия',
					si: 'Словения',
					tr: 'Турция',
					ua: 'Украина',
					fi: 'Финляндия',
					fr: 'Франция',
					hr: 'Хорватия',
					cz: 'Чехия',
					se: 'Швеция',
					ee: 'Эстония',
				},
				onlyCountries: [
					...agentsPage ? ['ru', 'th', 'in', 'id', 'ph', 'am', 'ge', 'uz', 'kg', 'by', 'rs', 'me', 'ae'] : [], 'kz', 'at', 'be', 'bg', 'hu', 'de', 'gr', 'dk', 'ie', 'es', 'it', 'cy', 'lv', 'lt', 'lu', 'mt', 'nl', 'no', 'pl', 'pt', 'ro', 'sk', 'si', 'tr', 'ua', 'fi', 'fr', 'hr', 'cz', 'se', 'ee',
				],
				customPlaceholder: (selectedCountryPlaceholder) => {
					return selectedCountryPlaceholder.replace(/[0-9]/g, '_');
				},
				utilsScript: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.16/js/utils.min.js',
			});

			containerLockScrollOnHover(iti.countryList);

			// eslint-disable-next-line
			$(phoneInputID).on('focus click countrychange', function () {
				let thisPlacholder = $(this).attr('placeholder');
				let res = thisPlacholder.replace(/_/g, '9');

				if (res !== 'undefined') {
					Inputmask(res, {
						placeholder: '_',
						clearMaskOnLostFocus: true,
						keepStatic: true,
					}).mask(this);

					labelLeft();
				}
			});

			$phoneNoResident.addEventListener('focusout', () => {
				let countryData = iti.getSelectedCountryData();
				let inputNonResidentCountryCode = document.querySelector('#nonResidentCountryCode');

				inputNonResidentCountryCode.value = countryData.iso2.toUpperCase();
			});

			$phoneNoResident.addEventListener('open:countrydropdown', () => {
				$phoneNoResident.closest('.form__item').classList.add('is-active');
			});

			$phoneNoResident.addEventListener('close:countrydropdown', () => {
				$phoneNoResident.closest('.form__item').classList.remove('is-active');
			});

			iti.countryList.addEventListener('mouseenter', () => {
				if (window.scrollbar) {
					window.scrollbar.updatePluginOptions('modal', {open: true});
				}
			});

			iti.countryList.addEventListener('mouseleave', () => {
				if (window.scrollbar) {
					window.scrollbar.updatePluginOptions('modal', {open: false});
				}
			});
		}

		if ($phoneResident) {
			const label = document.querySelector('label[for="phoneResident"]');

			const labelLeft = () => {
				let paddingInput = $phoneResident.style.paddingLeft;
				label.style.left = paddingInput;
			};

			setTimeout(() => {
				const $iti = document.querySelector('.iti');

				$iti.append(label);
				labelLeft();
			}, 250);
			const iti = intlTelInput($phoneResident, {
				autoPlaceholder: 'aggressive',
				separateDialCode: true,
				nationalMode: false,
				hiddenInput: 'phoneNumber',
				initialCountry: 'ru',
				localizedCountries: {
					ru: 'Россия',
				},
				onlyCountries: ['ru'],
				customPlaceholder: (selectedCountryPlaceholder) => {
					return selectedCountryPlaceholder.replace(/[0-9]/g, '_');
				},
				utilsScript: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.16/js/utils.min.js',
			});

			containerLockScrollOnHover(iti.countryList);

			// eslint-disable-next-line


			$(phoneInputIDRes).on('focus click countrychange', function () {
				let thisPlacholder = $(this).attr('placeholder');
				let res = thisPlacholder.replace(/_/g, '9');
				if (res !== 'undefined') {
					Inputmask(res, {
						placeholder: '_',
						clearMaskOnLostFocus: true,
						keepStatic: true,
					}).mask(this);

					labelLeft();
				}
			});

			$phoneResident.addEventListener('focusout', () => {
				let countryData = iti.getSelectedCountryData();
				let inputResidentCountryCode = document.querySelector('#residentCountryCode');

				inputResidentCountryCode.value = countryData.iso2.toUpperCase();
			});

			$phoneResident.addEventListener('open:countrydropdown', () => {
				$phoneResident.closest('.form__item').classList.add('is-active');
			});

			$phoneResident.addEventListener('close:countrydropdown', () => {
				$phoneResident.closest('.form__item').classList.remove('is-active');
			});
		}
		// eslint-disable-next-line
		$.validator.addMethod('validationNumber', function(value, element) {
			if (checkNumber(value) && onceShow) {
				onceShow = false;
			}
			return this.optional(element) || checkNumber(value);
		}, 'Неверно указан телефон');

		// eslint-disable-next-line
		$.validator.addMethod('validationUrl', function(value, element) {
			return this.optional(element) || isValidUrl(value);
		}, 'Неверно указан адрес');

		// eslint-disable-next-line
		$.validator.addMethod("phoneNumValidation", function(value, element) {
			// return iti.isValidNumber();
			value = value.replace(/_/g, '');
			value = value.replace(/\s+/g, '');

			const ssoRegex = /^([+]?[0-9\s-\(\)]{3,25})*$/i;
			if (countryWrapper.length != 0) {return true;}

			if ($phoneResident) {
				if (value.length > 11 && onceShow) {
					onceShow = false;
				}
				return ssoRegex.test(value) && value.length > 11;
			} else if ($phoneNoResident) {

				if (value.length > 6 && onceShow) {
					onceShow = false;
				}
				return ssoRegex.test(value) && value.length > 6;
			}
		}, 'Неверно указан телефон');

		$('#request-simple').validate({
			rules: {
				site: {
					...!agentsPage ? {
						required: true,
						minlength: 3,
						validationUrl: '',
					} : {},
				},
				country: {
					required: true,
				},
				phoneNumberVision: {
					required: true,
					phoneNumValidation: true,
				},
				comment: {
					required: true,
				},
			},
			messages: {
				// inn: 'Заполните ИНН',
				// registrationNumber: 'Заполните ИНН',
				// Firstname: 'Заполните это поле',
				site: {
					required: 'Введите адрес сайта',
				},
				phoneNumberVision: {
					required: 'Введите номер телефона',
				},
				email: {
					required: true,
					email: 'Некорректный e-mail адрес',
				},
				country: {
					required: true,
				},
				phone: {
					required: true,
					minlength: 'Номер телефона должен состоять минимум из 5 цифр',
				},
				comment: {
					required: 'Введите адрес сайта или комментарий',
				},
			},

			submitHandler: (form) => {
				if ($('#country').length != 0) {
					if (!$('#country').val()) {
						return false;
					}
				}
				// let captcha = grecaptcha.getResponse();
				// if (captcha.length === 0) {
				// 	popup.openPopup('Вы не прошли проверку "Я не робот"');
				// 	return false;
				// }
				// eslint-disable-next-line consistent-return
				const send = () => {
					const formUrlLead = '/ajax/sendlead.php';
					const formUrl = '/ajax/send.php';

					if (document.querySelector('#request-simple').querySelector('input[name="page"]')) {
						if (document.querySelector('#request-simple').querySelector('input[name="page"]').value === 'tips' || document.querySelector('#request-simple').querySelector('input[name="page"]').value === 'cloud-cheki') {
							sendAjaxForm(form, formUrlLead);

							return false;
						}
					}
					sendAjaxForm(form, formUrl);
				};

				const OpenSecondStep = (token) => {
					const formSecondStep = document.querySelector('#request-simple-second-step');
					let phone = form.querySelector('[name="phoneNumber"]').value.replace(/[() -]/g, '');
					requestSecondStep.init(token, phone);
				}

				if (document.getElementById('form-test')) {
					const key = 'ysc1_PtuKDChIa4fj9R2Ax6fUcHLr7GalhRy1StxQTIpl303bf975'
					popup.openPopup(`<div class="smart-captcha" id="captcha-container" data-sitekey=${key}></div>`);

					if (window.smartCaptcha) {
						console.info('SMART CAPTCHA');
						const container = document.getElementById('captcha-container');
						const widgetId = window.smartCaptcha.render(container, {
							sitekey: key,
							hl: 'ru',
							// test: true,
							callback: (token) => {
								document.querySelector('.smart-token').value = token;
							},
						});
						const success = window.smartCaptcha.subscribe(widgetId, 'success', (e) => {
							send();
						});
					}
				} else {
				// ssoAuth.init(form, OpenSecondStep);
					let phone = form.querySelector('[name="phoneNumber"]').value.replace(/[() -]/g, '');
					setStateForm('createdAt', Date.now());
					setStateForm('url', window.location.href);

					let encodedStateForm = encodeState(localStorage.getItem('form'));
					document.cookie = "formState="+encodedStateForm+"; max-age=3600; secure; path=/";
					//saving phone number after send token

					setStateForm('phone', phone);
					return;
				}

				return false;
			},
		});
	}
};

export default {
	init,
};
